import {InlineEditableTextfield} from "@atlaskit/inline-edit";
import type {ComponentProps} from "react";

export function AnankeInlineEditableTextField(props: ComponentProps<typeof InlineEditableTextfield>) {
    // Required if we are doing SSR. We can remove this check if we are no longer using it for any project.
    if (typeof window === "undefined") {
        return null;
    }

    return (
        <div className="[&>form>div]:mt-0!">
            <InlineEditableTextfield {...props} />
        </div>
    );
}
